import {
    FINTECH_SYNCLOG_LOADING,
    FINTECH_SYNCLOG_LOAD_SUCCESS,
    FINTECH_SYNCLOG_ERROR,
} from "./constants";
import { makePrivateApiCall } from "utilities/dist/api";

export const loadFintechSyncLogs = invoiceIds => dispatch => {
    dispatch({
        type: FINTECH_SYNCLOG_LOADING,
        payload: { invoiceIds }, // Optional: You might adjust payload structure based on reducer
    });

    makePrivateApiCall({
        url: `/fintech/sync-log?invoiceIds=${invoiceIds.join(",")}`,
        method: "get",
    })
        .then(res => {
            if (res.data) {
                // Assuming res.data is structured as an object {invoiceId: syncLogs[]}
                dispatch({
                    type: FINTECH_SYNCLOG_LOAD_SUCCESS,
                    payload: res.data,
                });
            }
        })
        .catch(err => {
            dispatch({
                type: FINTECH_SYNCLOG_ERROR,
                payload: { error: err.message, invoiceIds }, // Adjust according to how you handle errors
            });
        });
};
export const syncFintechInvoices = invoiceIds => dispatch => {
    dispatch({
        type: FINTECH_SYNCLOG_LOADING,
        payload: { invoiceIds }, // Optional: Adjust according to your needs
    });

    makePrivateApiCall({
        url: `/fintech/sync?invoiceIds=${invoiceIds.join(",")}`,
        method: "post",
    })
        .then(() => {
            // After triggering sync, reload the sync log data for these invoiceIds
            dispatch(loadFintechSyncLogs(invoiceIds));
        })
        .catch(err => {
            dispatch({
                type: FINTECH_SYNCLOG_ERROR,
                payload: { error: err.message, invoiceIds }, // Adjust according to how you handle errors
            });
        });
};
